/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { InvalidArgumentException } from '../../lib/exceptions';

export class OrderedMap {
  length = 0;
  private internalMap = new Map();
  private readonly keyProperty;
  private keys = [];

  constructor(keyProperty) {
    this.keyProperty = keyProperty;
  }

  push(obj) {
    if (!obj) {
      throw new InvalidArgumentException('Argument is not an object.');
    }
    if (!obj[this.keyProperty] && obj[this.keyProperty] !== 0) {
      throw new InvalidArgumentException(['Argument did not have a valid ', this.keyProperty, ' value.'].join('"'));
    }

    this[this.length] = obj[this.keyProperty];
    this.internalMap[this[this.length]] = obj;

    return ++this.length;
  }

  pop(index) {
    if (index > this.length) {
      throw new InvalidArgumentException('Index greater than length.');
    }
    if (index < 0) {
      throw new InvalidArgumentException('Index invalid');
    }

    for (let i = index; i < this.length; ++i) {
      if (i === index) {
        // wipe out the workList we want to delete in internal map
        delete this.internalMap[this[i]];
      }
      // don't move the last one down a spot
      if (i <= this.length - 1) {
        this[i] = this[i + 1];
      }
    }

    delete this[this.length - 1];
    const updatedMapLength = --this.length;
    this.length = updatedMapLength;
    this.keys.length = updatedMapLength;
    return updatedMapLength;
  }

  get(key) {
    return this.internalMap[key];
  }

  getByIndex(index) {
    return this.internalMap[this[index]];
  }
}
